// frontend/src/api/auth.js
// Funciones API para la autenticación de usuarios.

import { request } from './api';

/**
 * @function syncEntraSession
 * @description Sincroniza la sesión autenticada con Microsoft Entra ID en el backend.
 * @param {string} token - Token emitido por Microsoft Entra ID.
 * @returns {Promise<object>} - Datos de la respuesta, incluyendo el token JWT.
 */
export async function syncEntraSession(token) {
  return request('/api/auth/entra', 'POST', null, token);
}

/**
 * @deprecated Mantiene compatibilidad con el nombre anterior.
 */
export async function login(token) {
  return syncEntraSession(token);
}
